<template>
  <q-list
    dense
    style="min-width: 250px;"
  >
    <q-item-label header class="text-bold">
      {{ headerLabel }}
    </q-item-label>
    <template v-for="(line, key) in list" :key="key">
      <q-item-wrapper
        v-if="typeof line === 'string'"
        :label="line"
        :class="{'q-mt-sm': key > 0}"
        label-class="text-bold"
      />

      <q-item-wrapper
        v-else
        :active="isLineSelected(line.email_address)"
        tag="label"
        clickable
        @click="$emit('update:modelValue', line.email_address)"
      >
        <q-item-label>{{ line.email_address }}</q-item-label>

        <template v-if="line.field_name || multiple" #after>
          <q-item-section
            v-if="line.field_name"
            side
          >
            <q-item-label>{{ line.field_name }}</q-item-label>
          </q-item-section>

          <q-item-section v-if="multiple" side>
            <q-checkbox
              :model-value="isLineSelected(line.email_address)"
              dense
              size="sm"
              class="no-pointer-events"
            />
          </q-item-section>
        </template>
      </q-item-wrapper>
    </template>
  </q-list>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: [String, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    headerLabel: {
      type: String,
      default: 'Suggested Email Addresses'
    },
    list: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue'],
  methods: {
    isLineSelected (email) {
      email = email.toLowerCase()

      if (this.multiple) {
        if (!Array.isArray(this.modelValue)) {
          return false
        }
        return this.modelValue.includes(email)
      }
      return email === this.modelValue
    }
  }
}
</script>
